import { W as WuiToggle$1, d as defineCustomElement$1 } from './p-qPjg7fPi.js';

const WuiToggle = WuiToggle$1;
const defineCustomElement = defineCustomElement$1;

export { WuiToggle, defineCustomElement };
